import styled from 'styled-components';

import { lighten } from 'polished';

export const GradeTable = styled.table`
  width:100%;
  background: #eee;
`;

export const GradeHeader = styled.thead`
  background: ${lighten(0.4,'rgb(155,213,49)')};
  border-bottom:2px solid rgba(0,0,0,.05);

  td {
    padding:10px;
    font-weight: bold;
    font-size:14px;
  }

  td.iconSize {
    width:25px;
  }
`;

export const Dialog = styled.ul`
  position:absolute;
  z-index:2;
  left:0;
  top:100%;
  width:200px;
  background:rgb(155,213,49);
  border-radius:4px;
  display:none;
  cursor:auto;

  &::before {
    content:'';
    position:absolute;
    left:7px;
    top: -7px;
    width:0;
    height:0;
    border-left:7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 7px solid rgb(155,213,49);
    overflow:hidden;
  }

  li {
    border-bottom:1px solid rgba(0,0,0,.05);
    width:100%;
    padding:10px;
    cursor:pointer;
    transition:all .2s;
    color:#FFF;

    &:hover {
      color:#ccc;
    }

    &.trash:hover {
      cursor:pointer;
      background: rgba(215,47,47,1);
    }
  }
`;

export const GradeBody = styled.tbody`

  tr {
    width:100%;
    cursor:pointer;
    position:relative;

    &:nth-child(odd) {
      background: rgba(0,0,0,.05);
    }

    &:hover {
      background: ${lighten(0.5,'rgb(155,213,49)')};
    }

    &.active ul {
      display:block;
    }

    &.canceled {
      background: #888;
    }

    td {
      padding:10px;
      font-size:14px;
      border-bottom:1px solid rgba(0,0,0,.05);

      &:first-child {
        position:relative;
      }
    }
  }


`;

export const Filtros = styled.div`
  background: #eee;
  display:flex;
  flex-direction: row;
  align-items:center;
  height:39px;

  p {
    padding:0 20px;
  }
`;


export const New = styled.button`
  display:flex;
  flex-direction: row;
  padding:0 20px;
  align-items: center;
  border:none;
  border-left:1px solid rgba(0,0,0,.1);
  border-right:1px solid rgba(0,0,0,.1);
  height:39px;
  background:rgb(155,213,49);
  color:#FFF;
  font-weight:bold;
`;
